import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showDialog } from "../../../ducks/confirmDialog";
import { LINKS_SURVEY_ADMIN_ENTRY } from "../../../ducks/login";
import {
  messagesReceived,
} from "../../../ducks/message";
import {
  saveSurvey,
  SURVEY_VERSION,
  SURVEY_COMPARE_LATEST,
  SURVEY_COMPARE_OLD,
  SURVEY_IDENTIFIER,
  SURVEY_NAME,
  SURVEY_TEMPLATE,
  SURVEYS_COMPARE
} from "../../../ducks/survey";
import { TEMPLATE_LIST } from "../../../ducks/templatelist";
import { changeQuestionField, editPage, propertyChange } from "../../../ducks/surveyEditorActions";
import SurveyVersionCompare from "./SurveyVersionCompare";

/**
 * Container serves two purposes:
 * Binding of specified initial state elements to initial properties of SurveyVersionCompare.js.
 * Binding of specified properties of SurveyVersionCompare.js and its children to actions being handled in
 * SurveyVersionCompare.js.
 */
const mapStateToProps = (state) => {
  return {
    surveys: state.survey[SURVEYS_COMPARE],
    identifier: state.survey[SURVEY_IDENTIFIER],
    surveyVersionNumber: state.survey[SURVEY_VERSION],
    surveyName: state.survey[SURVEY_NAME],
    surveyAdminLink: state.login[LINKS_SURVEY_ADMIN_ENTRY],
    latestSurvey: state.survey[SURVEY_COMPARE_LATEST],
    lastApprovedSurvey: state.survey[SURVEY_COMPARE_OLD],
    surveyTemplate: state.survey[SURVEY_TEMPLATE],
    pages: state.surveyEditor.pages,
    templateList: state.templatelist[TEMPLATE_LIST]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      showDialog,
      propertyChange,
      changeQuestionField,
      saveSurvey,
      editPage,
      messagesReceived,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyVersionCompare);
